import axios from "axios";
import { MetaDataSchema } from "./types";

export const getMetadata = async () => {
  const { data } = await axios.get<unknown>("/data/metadata.json");

  const metadata = MetaDataSchema.parse(data);

  for (const category in metadata.categories) {
    metadata.categories[category] = metadata.categories[category].map((asset) => ({
      ...asset,
      path: `/${asset.path}`,
    }));
  }

  return metadata;
};
